module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aXSkw"))).then(() => parcelRequire('hEqeo'));